import React, { useContext } from 'react'
import { useUpsertSchoolGroup } from '@hooks/mutations/useUpsertSchoolGroup'
import { AppContext } from '@state/context'
import { closePanel } from '@state/actions/panelsActions'
import { PANELS } from '@helpers/constants'
import { useSchoolGroup } from '@hooks/useSchoolGroup'
import AddStudentToSchoolResourcePanel from '.'

const AddStudentToSchoolGroupPanel = () => {
  const [state, dispatch] = useContext(AppContext)
  const {
    panels: {
      panelData: { schoolId, schoolGroupId },
    },
  } = state
  const { schoolGroup } = useSchoolGroup(schoolGroupId)
  const { post } = useUpsertSchoolGroup()

  const onSubmit = async (data) => {
    const studentIdsToConnect = data.students.reduce(
      (acc, student) =>
        Object.prototype.hasOwnProperty.call(student, 'value')
          ? [...acc, student.value]
          : acc,
      []
    )

    let successMessage =
      studentIdsToConnect.length === 1 ? 'Elev tillagd.' : 'Elever tillagda.'
    let errorMessage =
      studentIdsToConnect.length === 1
        ? 'Något gick fel när elev skulle läggas till.'
        : 'Något gick fel när elever skulle läggas till.'

    const res = await post(
      {
        id: schoolGroupId,
        students: { connect: studentIdsToConnect },
      },
      successMessage,
      errorMessage
    )

    if (res.success) dispatch(closePanel(PANELS.ADD_STUDENT_TO_SCHOOL_GROUP))
  }

  return (
    <AddStudentToSchoolResourcePanel
      resource={schoolGroup}
      handleSubmit={onSubmit}
      schoolId={schoolId}
      panelType={PANELS.ADD_STUDENT_TO_SCHOOL_GROUP}
    />
  )
}

export default AddStudentToSchoolGroupPanel
